<script setup lang="ts">
import { Text } from '~ds/components/ui/typography';

interface Props {
  name: string;
  logoUrl?: string | null;
}

withDefaults(defineProps<Props>(), { logoUrl: null });
</script>

<template>
  <div class="flex items-center gap-3" data-testid="video-sponsor">
    <NuxtImg
      v-if="logoUrl"
      :src="logoUrl"
      alt=""
      width="112"
      class="size-14 shrink-0 rounded-full bg-card object-contain p-1"
    />
    <div class="flex flex-col gap-1">
      <Text size="xs" class="text-muted-foreground">
        {{ $t('unified.videos.sponsoredBy') }}
      </Text>
      <Text weight="semibold">
        {{ name }}
      </Text>
    </div>
  </div>
</template>
